import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["companyName", "demoButton", "detailsButton", "featureHeadlines", "installsCount", "name", "offeringType", "priceCents", "reviewSummary", "thumbnailUrl"];
import { FormattedIntlCurrency } from 'I18n/components/FormattedIntlCurrency';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Small } from 'foundations-components/transitional/components/Small';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { List } from 'foundations-components/transitional/components/List';
import { Text } from 'foundations-components/components/Text';
import { CardWrapper } from 'foundations-components/transitional/components/Card';
import { Image } from 'foundations-components/transitional/components/Image';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { formatCentsToDollars } from 'marketplace-ui-common/utils/currency';
import { bucketInstalls } from 'marketplace-ui-common/utils/installs';
import Rating from 'marketplace-ui-reviews/components/Rating';
import { STAR_RATING_FILLED } from 'marketplace-ui-reviews/constants/RatingTypes';
import { MINIMUM_REVIEWS_FOR_DISPLAY } from 'marketplace-ui-reviews/constants/ReviewsListQueries';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AssetListViewCard(_ref) {
  let {
      companyName,
      demoButton,
      detailsButton,
      featureHeadlines,
      installsCount,
      name,
      offeringType,
      priceCents,
      reviewSummary,
      thumbnailUrl
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.SM]: false
    }
  });
  const installsBucket = bucketInstalls(installsCount);
  return /*#__PURE__*/_jsx(CardWrapper, Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(MultiColumn, {
      flush: true,
      padding: "400",
      children: /*#__PURE__*/_jsxs(MultiColumnGroup, {
        children: [/*#__PURE__*/_jsx(MultiColumnItem, {
          width: "275px",
          paddingInlineEnd: "0",
          children: /*#__PURE__*/_jsx(Image, {
            shape: "thumbnail",
            src: thumbnailUrl || '',
            maxBlockSize: !isMobileView ? '200px' : undefined
          })
        }), /*#__PURE__*/_jsxs(MultiColumnItem, {
          verticalAlign: "top",
          paddingBlockStart: "100",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h4",
            children: name
          }), /*#__PURE__*/_jsx("div", {
            children: /*#__PURE__*/_jsx(Small, {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-ui-assets-core.assetCard.companyName",
                options: {
                  companyName: companyName || ''
                }
              })
            })
          }), /*#__PURE__*/_jsx(View, {
            paddingBlockStart: "100",
            paddingBlockEnd: "200",
            as: "div",
            children: /*#__PURE__*/_jsx(Badge, {
              use: offeringType === 'THEME' ? 'thunderdome' : 'norman',
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: `marketplace-ui-assets-core.assetCard.offeringType.${offeringType}`
              })
            })
          }), /*#__PURE__*/_jsx(List, {
            styled: true,
            marginInlineStart: "400",
            paddingInlineStart: "0",
            wrapChildren: true,
            children: featureHeadlines.map((item, index) => /*#__PURE__*/_jsx(Small, {
              children: item
            }, `featuredheadline-${index}`))
          })]
        }), /*#__PURE__*/_jsxs(MultiColumnItem, {
          width: "200px",
          horizontalAlign: "center",
          paddingInlineStart: "0",
          children: [/*#__PURE__*/_jsx("div", {
            children: priceCents != null ? /*#__PURE__*/_jsx(Text, {
              as: "h3",
              children: priceCents === 0 ? /*#__PURE__*/_jsx(FormattedMessage, {
                message: "marketplace-ui-assets-core.assetCard.planType.free"
              }) : /*#__PURE__*/_jsx(FormattedIntlCurrency, {
                currencyCode: "USD",
                trailingZeroDisplay: "stripIfInteger",
                value: formatCentsToDollars(priceCents)
              })
            }) : null
          }), /*#__PURE__*/_jsx(View, {
            paddingBlockStart: "200",
            paddingBlockEnd: "200",
            as: "div",
            children: reviewSummary && reviewSummary.reviewCount >= MINIMUM_REVIEWS_FOR_DISPLAY ? /*#__PURE__*/_jsx(Rating, {
              rating: reviewSummary.overallRating,
              label: reviewSummary.reviewCount,
              showTextRating: true,
              use: "card",
              type: STAR_RATING_FILLED,
              justify: "center"
            }) : /*#__PURE__*/_jsx("span", {})
          }), /*#__PURE__*/_jsx(Small, {
            children: installsBucket > 0 ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
              message: "marketplace-assets-ui.assets.assetListViewCard.installsBucket.bucket_jsx",
              elements: {
                Number: FormattedNumber
              },
              options: {
                value: installsBucket
              }
            }) : /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplace-assets-ui.assets.assetListViewCard.installsBucket.min"
            })
          }), (detailsButton || demoButton) && /*#__PURE__*/_jsxs(TFlex, {
            direction: "row",
            align: "center",
            wrap: isMobileView ? 'wrap' : 'nowrap',
            paddingBlockStart: "200",
            paddingBlockEnd: "200",
            children: [detailsButton, demoButton]
          })]
        })]
      })
    })
  }));
}